import React from 'react'
export var ODStringRenderer = function (props) {
  var value = props.value,
    fixedString = props.fixedString
  if (fixedString) {
    return React.createElement('span', null, fixedString)
  }
  return React.createElement('span', null, value)
}
//# sourceMappingURL=ODStringRenderer.js.map
